import { render, staticRenderFns } from "./ListaAnexoBase.vue?vue&type=template&id=55e83094&scoped=true"
import script from "./ListaAnexoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaAnexoBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListaAnexoBase.vue?vue&type=style&index=0&id=55e83094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e83094",
  null
  
)

export default component.exports